import { atom, useAtom } from 'jotai';

export const tabItemIdAtom = atom(null);

export function useTabItemIdAtom() {
  return useAtom(tabItemIdAtom);
}
